import Design from "@material-symbols/svg-500/rounded/stylus_note.svg?react";
import { memo } from "react";

import type { SVGIconProps } from "@/components/ui/icon/_utils/icon-creator";
import { IconCreator } from "@/components/ui/icon/_utils/icon-creator";

const DesignIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: Design });
	return <Icon />;
};

export default memo(DesignIcon);
